<template>
  <div>
    一、tab基本用法，可嵌套
    <SjTab v-model="model1" type="card">
      <SjTabPane name="t1" label="标签1标签1标签1标签1" :lazy="true" border>
        <br />
        嵌套tab
        <SjTab v-model="model3" type="card" size="middle" style="margin:10px">
          <SjTabPane name="t1" label="标签1" :lazy="true">t1</SjTabPane>
          <SjTabPane name="t2">
            <span slot="label"
              ><i class="el-icon-date"></i> 标标签2标签2签2</span
            >
            t2
          </SjTabPane>
          <SjTabPane name="t3" label="标签3" border>t3</SjTabPane>
        </SjTab>
      </SjTabPane>
      <SjTabPane name="t2">
        <span slot="label"><i class="el-icon-date"></i> 标签2</span>
        t2
      </SjTabPane>
      <SjTabPane name="t3" label="标签3" border>t3</SjTabPane>
    </SjTab>
    <br />
    <br />
    二、card形式tab可以额外配置自定义功能区
    <SjTab v-model="model1" type="card" size="middle">
      <div slot="after" style="display:flex">
        <sj-checkbox
          size="small"
          label="显示图标"
          v-model="checkbox"
          style="width:100px"
        >
        </sj-checkbox>
        <sj-input
          border
          size="small"
          v-model="input"
          style="width:200px"
        ></sj-input>
      </div>
      <SjTabPane name="t1" :label="input" :lazy="true">t1</SjTabPane>
      <SjTabPane name="t2">
        <span slot="label"
          ><i class="el-icon-date" v-if="checkbox"></i> 标签2</span
        >
        t2
      </SjTabPane>
      <SjTabPane name="t3" label="标签3">t3</SjTabPane>
    </SjTab>
    <br />
    <br />
    三、为tab指定高度可实现tabpane的滚动效果
    <SjTab v-model="model2" type="page" style="height: 200px;width: 400px">
      <SjTabPane name="t1" label="标签1" :lazy="true">
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
        <div>t1</div>
      </SjTabPane>
      <SjTabPane name="t2">
        <span slot="label"><i class="el-icon-date"></i> 标签2</span>
        t2
      </SjTabPane>
      <SjTabPane name="t3" label="标签3">
        <SjTab v-model="model3" type="card" size="middle">
          <SjTabPane name="t1" label="标签1" :lazy="true">t1</SjTabPane>
          <SjTabPane name="t2">
            <span slot="label"><i class="el-icon-date"></i> 标签2</span>
            t2
          </SjTabPane>
          <SjTabPane name="t3" label="标签3" border>t3</SjTabPane>
        </SjTab>
      </SjTabPane>
    </SjTab>
    <br />
    <br />

    <SjTab
      v-model="model2"
      type="page"
      style="height: 300px;width: 400px"
      size="middle"
    >
      <SjTabPane name="t1" label="标签1" :lazy="true">
        t1
      </SjTabPane>
      <SjTabPane name="t2">
        <span slot="label"><i class="el-icon-date"></i> 标签2</span>
        t2
      </SjTabPane>
      <SjTabPane name="t3" label="标签3">
        t3
      </SjTabPane>
    </SjTab>
    四、chrome形态
    <SjTab v-model="model4" type="chrome" editable @tab-close="handleClose">
      <div slot="before">
        before
      </div>
      <SjTabPane
        v-for="item in tabList"
        :key="item.name"
        :name="item.name"
        :label="item.label"
        border
        >{{ item.name }}</SjTabPane
      >
    </SjTab>
  </div>
</template>

<script>
export default {
  data() {
    return {
      model1: "t2",
      checkbox: false,
      input: "标签1",
      model2: "t1",
      model3: "t1",
      tabList: Array.from({ length: 40 }).map((item, index) => ({
        name: `t${index}`,
        label: `标签${index}`
      })),
      model4: "t0"
    };
  },
  methods: {
    handleClose(name, index) {
      this.tabList.splice(index, 1);
      if (this.tabList.length && name === this.model4) {
        if (index < this.tabList.length) {
          this.model4 = this.tabList[index].name;
        } else {
          this.model4 = this.tabList[index - 1].name;
        }
      }
    }
  }
};
</script>
